function setPath(svgPath) {
    let pathLength = svgPath.getTotalLength()
    svgPath.style.strokeDasharray = pathLength
    svgPath.style.strokeDashoffset = `${pathLength}`
    svgPath.style.transitionDuration = '0s'
    svgPath.style.transitionTimingFunction = 'ease'
}

export default setPath